module.exports = __webpack_public_path__ + "static/img/center_img7.672389fb.png";